







import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';

@Component
export default class SidebarPortfolio extends Vue {
    get filter() {
        return user.companyFilter;
    }
    set filter(filter: string) {
        user.setCompanyFilter(filter);
    }
}
